import { render } from "./ResetPasswordConfirmation.vue?vue&type=template&id=5dd3f9ad"
import script from "./ResetPasswordConfirmation.vue?vue&type=script&lang=js"
export * from "./ResetPasswordConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__